import ConfigClient, {getMarketConfigList} from './configClient';

let marketConfigsList;

if (process.env.REACT_APP_IS_BUILD_REF === 'true') {
    marketConfigsList = [
        {
            urls: [`https://preprod.iqos.ro/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-1" */ `../marketConfigs/ro/qa-preprod-ref`),
        },
        {
            urls: [`https://preprod.iqos.co.nz/`, `https://ct-staging.pmi-dcs.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-2" */ `../marketConfigs/nz/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/cz/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-3" */ `../marketConfigs/cz/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/ch/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-4" */ `../marketConfigs/ch/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/fr/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-5" */ `../marketConfigs/fr/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.veev-vape.com/fi/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-6" */ `../marketConfigs/fi/qa-preprod-ref`),
        },
        {
            urls: [`https://preprod.iqos.gr/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-10" */ `../marketConfigs/gr/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.veev-vape.com/ca/`, `https://preprod.iqos.ca/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-11" */ `../marketConfigs/ca_p4/qa-preprod-ref`),
        },
        {
            urls: [`https://on-preprod.iqos.ca/`, `https://on-pp.qlabstore.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-12" */ `../marketConfigs/caon/qa-preprod-ref`),
        },
        {
            urls: [`https://ab-preprod.iqos.ca/`, `https://ab-pp.qlabstore.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-13" */ `../marketConfigs/caab/qa-preprod-ref`),
        },
        {
            urls: [`https://bc-preprod.iqos.ca/`, `https://bc-pp.qlabstore.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-14" */ `../marketConfigs/cabc/qa-preprod-ref`),
        },
        {
            urls: [`https://pl.qa-iqos.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-15" */ `../marketConfigs/pl_p1/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/hr/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-16" */ `../marketConfigs/hr_p1/qa-preprod-ref`),
        },
        {
            urls: [`https://preprod.myiqos.nl/`, `https://preprod.iqos.nl/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-18" */ `../marketConfigs/nl/qa-preprod-ref`),
        },
        {
            urls: [`https://preprod.iqos.com.ua/`, `https://iqosdev.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-19" */ `../marketConfigs/ua/qa-preprod-ref`),
        },
        {
            urls: [`https://es.qa-iqos.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-20" */ `../marketConfigs/es_p1/qa-preprod-ref`),
        },
        {
            urls: [`https://preprod-voyager.jp.stg-iqos.com/apps/webapp`, `https://jp.stg-iqos.com/apps/webapp`],
            configImport: () => import(/* webpackChunkName: "lazy-chunk.21" */ `../marketConfigs/jp/qa-preprod-ref`),
        },
        {
            urls: [`https://preprod.iqos.co.il/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-50" */ `../marketConfigs/il/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/jo/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-51" */ `../marketConfigs/jo/qa-preprod-ref`),
        },
        {
            urls: [`https://preprod.iqos.lt/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-52" */ `../marketConfigs/lt_p1/qa-preprod-ref`),
        },
        {
            urls: [`https://lb.qa-iqos.com/`, `https://iqoslbweb-staging.azurewebsites.net/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-53" */ `../marketConfigs/lb_p1/qa-preprod-ref`),
        },
        {
            urls: [`https://preprod.iqos.it/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-55" */ `../marketConfigs/it_p1/qa-preprod-ref`),
        },
        {
            urls: [`https://qc-main-preprod.iqos.ca/`, `https://qc-preprod.iqos.ca/`, `https://qc-pp.qlabstore.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-56" */ `../marketConfigs/caqc/qa-preprod-ref`),
        },
        {
            urls: [`https://preprod.iqos.pt/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-57" */ `../marketConfigs/pt/qa-preprod-ref`),
        },
        {
            urls: [`https://ps.qa-iqos.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-58" */ `../marketConfigs/ps/qa-preprod-ref`),
        },
        {
            urls: [`https://iqos.apps.one.com.tr/`, `https://trnc.dev-iqos.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-59" */ `../marketConfigs/nc/qa-preprod-ref`),
        },
        {
            urls: [`https://kzpre.iqos.com/`, `https://pre.kz.iqos.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-60" */ `../marketConfigs/kz/qa-preprod-ref`),
        },
        {
            urls: [`https://iqos-bg-next.stage.bylith.com/`, `https://iqos-bg-staging.stage.bylith.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-61" */ `../marketConfigs/bg_p1/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/mv/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-62" */ `../marketConfigs/mv/qa-preprod-ref`),
        },
        {
            urls: [`https://preprod.iqos.se/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-63" */ `../marketConfigs/se/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/de/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-64" */ `../marketConfigs/de/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/sk/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-65" */ `../marketConfigs/sk/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/id/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-66" */ `../marketConfigs/id/qa-preprod-ref`),
        },
        {
            urls: [`https://iqos-hu-next.stage.bylith.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-67" */ `../marketConfigs/hu/qa-preprod-ref`),
        },
        {
            urls: [`https://mb-pp.qlabstore.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-68" */ `../marketConfigs/camb/qa-preprod-ref`),
        },
        {
            urls: [`https://nb-pp.qlabstore.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-69" */ `../marketConfigs/canb/qa-preprod-ref`),
        },
        {
            urls: [`https://nl-pp.qlabstore.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-70" */ `../marketConfigs/canl/qa-preprod-ref`),
        },
        {
            urls: [`https://ns-pp.qlabstore.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-71" */ `../marketConfigs/cans/qa-preprod-ref`),
        },
        {
            urls: [`https://pe-pp.qlabstore.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-72" */ `../marketConfigs/cape/qa-preprod-ref`),
        },
        {
            urls: [`https://sk-pp.qlabstore.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-73" */ `../marketConfigs/cask/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/ae/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-74" */ `../marketConfigs/ae/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/eg/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-76" */ `../marketConfigs/eg/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/gb/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-77" */ `../marketConfigs/gb/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/kg/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-78" */ `../marketConfigs/kg/qa-preprod-ref`),
        },
        {
            urls: [`https://preprod.iqos.dk/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-54" */ `../marketConfigs/dk_p1/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/si/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-78" */ `../marketConfigs/si/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/ph/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-81" */ `../marketConfigs/ph/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/gt/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-82" */ `../marketConfigs/gt/qa-preprod-ref`),
        },
        {
            urls: [`https://malaysia.qa-iqos.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-83" */ `../marketConfigs/my/qa-preprod-ref`),
        },
        {
            urls: [
                `https://iqos-cy-next.stage.bylith.com/`,
                `https://iqos-cy-uc2.stage.bylith.com/`,
                `https://iqos-cy-testing.stage.bylith.com/`,
            ],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-84" */ `../marketConfigs/cy/qa-preprod-ref`),
        },
        {
            urls: [`https://iqos-rs-next.stage.bylith.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-85" */ `../marketConfigs/rs/qa-preprod-ref`),
        },
        {
            urls: [`https://sa.dev-iqos.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-86" */ `../marketConfigs/sa/qa-preprod-ref`),
        },
        {
            urls: [`https://iqos-al-next.stage.bylith.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-87" */ `../marketConfigs/al/qa-preprod-ref`),
        },
        {
            urls: [`https://iqos-mk-next.stage.bylith.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-88" */ `../marketConfigs/mk/qa-preprod-ref`),
        },
        {
            urls: [`https://iqos-ba-next.stage.bylith.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-89" */ `../marketConfigs/ba/qa-preprod-ref`),
        },
        {
            urls: [`https://iqos-me-next.stage.bylith.com/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-90" */ `../marketConfigs/me/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/tn/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-91" */ `../marketConfigs/tn/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/az/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-92" */ `../marketConfigs/az/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/ly/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-93" */ `../marketConfigs/ly/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/ma/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-94" */ `../marketConfigs/ma/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/mx/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-95" */ `../marketConfigs/mx/qa-preprod-ref`),
        },
        {
            urls: [`https://www.pp.iqos.com/pk/`],
            configImport: () =>
                import(/* webpackChunkName: "lazy-chunk.qa-pp-96" */ `../marketConfigs/pk/qa-preprod-ref`),
        },
    ];
} else {
    const envUrl = 'https://iqos-connect-preprod-web.iot.qa-pmidce.com';
    const rrpEnvUrl = 'https://iqos-connect-preprod-web.rrp-backend.com';
    const deepEnvUrl = 'https://pmi-app-icwa-preprod-web.rrp-backend.com';

    marketConfigsList = getMarketConfigList((marketName) => {
        return {
            urls: [`${envUrl}/${marketName}`, `${rrpEnvUrl}/${marketName}`, `${deepEnvUrl}/${marketName}`],
            configImport: () => import(`../marketConfigs/${marketName}/qa-preprod-web`),
        };
    });
}

export default class ConfigClientQAPreprod extends ConfigClient {
    constructor() {
        super(marketConfigsList);
    }
}
